module.exports = __webpack_public_path__ + "img/10.2fbdc1fb.jpg";